import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FieldConfig} from 'src/app/shared/components/dynamic-forms-components/field.interface';
import {ProfileObject} from "../login/login.graphql";
import {StorageService} from "../../services/storage.service";
import {Location} from "@angular/common";
import {AuthService} from "../../services/auth.service";
import {Institution} from "../../store/entities/system-settings/institution/institution.model";
import {NotificationService} from "../../services/notification.service";
import {AttachmentService} from "../../services/attachment.service";
import {environment} from "../../../environments/environment";
import { Designation } from 'src/app/store/entities/instution-settings/designation/designation.model';
import {phoneNumbervalidator} from "../../shared/validators/input-validators";

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  title: string;
  fields: FieldConfig[];
  userProfileForm: FormGroup;
  userDesignationForm: FormGroup;
  userInstutionForm: FormGroup;

  hide: boolean = true;

  profile: ProfileObject

  designation: Designation
  isReadOnlyForProf: boolean = true
  isReadOnlyForInst: boolean = true
  isReadOnlyForDes: boolean = true


  changedImageForPro: boolean = false
  changedImageForInstu: boolean = false
  imageFromFileForPro: any = null
  imageFromFileForInstu: any = null
  institution: Institution

  changedProfileImageUrl: string
  changedInstuImageUrl: string

  fileServer: string = environment.FILE_SERVER_URL

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private attachmentService: AttachmentService,
    private location: Location
  ) {
  }


  ngOnInit(): void {
    this.loadData()
  }

  goBack() {
    this.location.back();
  }

  selectedImageForPro(profile: File) {
    let that = this
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {

      let response = await that.attachmentService.uploadSingleFile({
        fileName: profile.name,
        base64String: event.target.result.toString().split(';base64,')[1]
      })

      if (response.response.status) {
        this.changedImageForPro = true
        this.imageFromFileForPro = event.target.result;
        this.changedProfileImageUrl = response?.data?.imagePath

        await this.authService.updateUserProfile({
          profilePhone: this.profile?.profilePhone,
          profileTitle: this.profile?.profileTitle,
          profileType: this.profile?.profileType,
          profileUniqueId: this.profile?.profileUniqueId,
          userEmail: this.profile?.userEmail,
          userFirstName: this.profile?.userFirstName,
          userLastName: this.profile?.userLastName,
          profilePhoto: this.changedProfileImageUrl
        })

      } else {
        await that.notificationService.errorMessage(response.response.message);
      }
    });
    reader.readAsDataURL(profile);
  }

  selectedImageForInstu(instituion: File) {
    let that = this
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {

      let response = await that.attachmentService.uploadSingleFile({
        fileName: instituion.name,
        base64String: event.target.result.toString().split(';base64,')[1]
      })

      if (response.response.status) {
        this.changedImageForInstu = true
        this.imageFromFileForInstu = event.target.result;
        this.changedInstuImageUrl = response.data.imagePath

        await this.authService.updateInstitution({
          districtUniqueId: this.institution?.institutionDistrict?.districUniqueId,
          institutionUniqueId:this.institution?.institutionUniqueId,
          institutionLogo:this.changedInstuImageUrl,
          ministryUniqueId:this.institution?.institutionMinistry?.ministryUniqueId,
          sectorUniqueId:this.institution?.institutionSector?.sectorUniqueId,
          institutionEmail: this.institution?.institutionEmail,
          institutionMapUrl: this.institution?.institutionMapUrl,
          institutionName: this.institution?.institutionName,
          institutionPhones: this.institution?.institutionPhones,
          institutionPhysicalAddress: this.institution?.institutionPhysicalAddress,
          institutionPostcode: this.institution?.institutionPostcode,
          institutionShortform: this.institution?.institutionShortform,
          institutionType: this.institution?.institutionType,
          wardUniqueId: this.institution?.institutionWard?.wardUniqueId,
          institutionWebsite: this.institution?.institutionWebsite,
          streetUniqueId: this.institution?.institutionStreet?.streetUniqueId,
          regionalUniqueId: this.institution?.institutionRegion?.regionalUniqueId
        })
      } else {
        await that.notificationService.errorMessage(response.response.message);
      }
    });
    reader.readAsDataURL(instituion);
  }


  selectedImageForDes(instituion: File) {
    let that = this
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {

      let response = await that.attachmentService.uploadSingleFile({
        fileName: instituion.name,
        base64String: event.target.result.toString().split(';base64,')[1]
      })

      if (response.response.status) {
        this.changedImageForInstu = true
        this.imageFromFileForInstu = event.target.result;
        this.changedInstuImageUrl = response.data.imagePath
      } else {
        await that.notificationService.errorMessage(response.response.message);
      }
    });
    reader.readAsDataURL(instituion);
  }

  loadData() {
    this.profile = this.storageService.getItem('profile')
    this.institution = this.storageService.getItem('institution');
    this.designation = this.storageService.getItem('designation');

// user form
    this.userProfileForm = this.fb.group({
      profileTitle: [this.profile.profileTitle, Validators.required],
      userFirstName: [this.profile.userFirstName, Validators.required],
      userLastName: [this.profile.userLastName, Validators.required],
      userEmail: [this.profile.userEmail, Validators.required],
      profilePhone: [this.profile.profilePhone, [Validators.required, Validators.pattern(phoneNumbervalidator)]],
      profilePhoto: [this.profile.profilePhoto, Validators.required],
      designationName: [this.designation?.designationName, Validators.required],
      designationShortForm: [this.designation?.designationShortForm, Validators.required],
    })


// instituion user form
    this.userInstutionForm = this.fb.group({
      institutionName: [this.institution?.institutionName, Validators.required],
      institutionType: [this.institution?.institutionType, Validators.required],
      institutionShortform: [this.institution?.institutionShortform, Validators.required],
      institutionPhysicalAddress: [this.institution?.institutionPhysicalAddress, Validators.required],
      institutionEmail: [this.institution?.institutionEmail, Validators.required],
      institutionPostcode: [this.institution?.institutionPostcode, Validators.required],
      institutionWebsite: [this.institution?.institutionWebsite, Validators.required],
      institutionPhones: [this.institution?.institutionPhones, [Validators.required, Validators.pattern(phoneNumbervalidator)]],
      institutionMapUrl: [this.institution?.institutionMapUrl, Validators.required],
      ministryName:[this.institution?.institutionMinistry?.ministryName, Validators.required],
      sectorName:[this.institution?.institutionSector?.sectorName, Validators.required],
    })


  }

  valueChecker(value: any) {
    return value ? value : '-'
  }

  async submitForUserProfile(formValues) {

     const updatedFormValues = { ...formValues };
     delete updatedFormValues?.designationName;
     delete updatedFormValues?.designationShortForm;

    await this.authService.updateUserProfile({
      ...updatedFormValues,
      profileUniqueId: this.profile.profileUniqueId,
      profilePhoto: this.profile?.profilePhoto
    })
    this.isReadOnlyForProf = true
    this.loadData()
  }

  async submitForInstution(formValues) {

     const updatedFormValues = { ...formValues };
     delete updatedFormValues?.ministryName;
     delete updatedFormValues?.sectorName;

    await this.authService.updateInstitution({
      ...updatedFormValues,
      institutionUniqueId:this.institution?.institutionUniqueId,
      institutionLogo:this.institution?.institutionLogo,
      ministryUniqueId:this.institution?.institutionMinistry?.ministryUniqueId,
      sectorUniqueId:this.institution?.institutionSector?.sectorUniqueId
    })
    this.isReadOnlyForInst = true
    this.loadData()
  }

}
